import config from '..';

export const updateConfig = (update = {}) => Object.assign(config, update);
